import { Injectable, Injector } from '@angular/core';
import { SendFaxBaseService } from '@core/services/send-fax/send-fax-base.service';
import { IAuthorizationDTO } from '../../models/authorization.model';
import { TenantNames } from '@mynexus/mynexus-ui-lib';
import { DocumentFileType } from '@app/core/model';
import { IDocumentResponseDTO } from '@products/dmepos/models';
import { map } from 'rxjs';

export interface DocumentReferenceDTO {
  documentReferenceByProductId: string,
  reference: string,
  description: string,
  sortOrder: number,
  entity: string,
  applicationKey: string
} 

@Injectable({
  providedIn: 'root'
})
export class SendFaxDmeposService extends SendFaxBaseService {
  /**
   * DMEPOS has statically defined list of allowed document types
   */
  documentTypeConfig = null;

  constructor(injector: Injector) {
    super(injector);
  }

  sendLetter(payload: any, authorizationId: string, tenantId?: string) {
    return this.http.post<boolean>(`${this.getBaseUrl(tenantId, authorizationId)}/Letter/CreateDocument`, payload);
  }

  sendFax(payload: any, authorizationId: string,tenantId: string) {
    return this.http.post<boolean>(`${this.getBaseUrl(tenantId, authorizationId)}/Fax/CreateFax`, payload);
  }

  getDocumentTypes(authorization?: IAuthorizationDTO, tenantName?: TenantNames): DocumentFileType[] | any {
    return this.http.get<DocumentReferenceDTO[]>(`${this.apiUrl}` + `/tenants/${this.shellService.getTenantId()}/authorization/${authorization.authorizationByProduct.authorizationByProductId}/DocumentReferences?reference=Fax&entity=DocumentType`)
    .pipe(map((references: DocumentReferenceDTO[]) => references.sort((a,b) => a.sortOrder - b.sortOrder).map(x => {
      return <DocumentFileType>{
        documentTypeId: x.sortOrder,
        documentTypeCode: x.applicationKey,
        documentDisplayName: x.description
      }
    })));
  }

  filterDocuments(documents: IDocumentResponseDTO[]): IDocumentResponseDTO[] {
    return documents;
  }

  private getBaseUrl(tenantId: string, id: string): string {
    return `${this.apiUrl}/tenants/${tenantId}/authorizations/${id}`;
  }
}
